export default class CustomerAddress {
  constructor (customerId, type) {
    this.actions = {
      create: 'createCustomerAddress',
      update: 'updateCustomerAddress',
      remove: 'deleteCustomerAddress'
    }

    this.requestData = { customerId, type }
    this.name = 'address'
  }

  isNew (data) {
    return data.id === null || data.id === undefined
  }

  isEmpty (data) {
    return data.addressLine1 === '' || data.addressLine1 === null || data.addressLine1 === undefined
  }

  static empty () {
    return { label: '', countryCode: 'DE', area: '', locality: '', postalCode: '', addressLine1: '', id: null }
  }

  static parse (data) {
    return {
      id: data.id,
      label: data.label || '',
      countryCode: data.countryCode || '',
      area: data.area || '',
      locality: data.locality || '',
      postalCode: data.postalCode || '',
      addressLine1: data.addressLine1 || ''
    }
  }

  static parseResponseData (response) {
    let address = response.addresses

    response.addresses = (address && address.data && address.data.length > 0)
      ? address.data.map(CustomerAddress.parse)
      : []

    return response
  }
}
